// Auto-generated file - DO NOT EDIT MANUALLY
// Run 'npm run generate:stickers' to regenerate this file

export interface StickerCategory {
  name: string;
  stickers: string[];
}

export const STICKER_CATEGORIES: StickerCategory[] = [
  {
    name: "Bán Mình Cho Tư Bản",
    stickers: [
      "/assets/images/stickers/Bán Mình Cho Tư Bản/1.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/2.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/3.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/4.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/5.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/6.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/7.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/8.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/9.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/10.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/11.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/12.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/13.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/14.png",
      "/assets/images/stickers/Bán Mình Cho Tư Bản/15.png"
    ]
  },
  {
    name: "Creative Vibes",
    stickers: [
      "/assets/images/stickers/Creative Vibes/1.png",
      "/assets/images/stickers/Creative Vibes/2.png",
      "/assets/images/stickers/Creative Vibes/3.png",
      "/assets/images/stickers/Creative Vibes/4.png",
      "/assets/images/stickers/Creative Vibes/5.png",
      "/assets/images/stickers/Creative Vibes/6.png",
      "/assets/images/stickers/Creative Vibes/7.png",
      "/assets/images/stickers/Creative Vibes/8.png",
      "/assets/images/stickers/Creative Vibes/9.png",
      "/assets/images/stickers/Creative Vibes/10.png"
    ]
  },
  {
    name: "Cò Lõ",
    stickers: [
      "/assets/images/stickers/Cò Lõ/1.png",
      "/assets/images/stickers/Cò Lõ/2.png",
      "/assets/images/stickers/Cò Lõ/3.png",
      "/assets/images/stickers/Cò Lõ/4.png",
      "/assets/images/stickers/Cò Lõ/5.png",
      "/assets/images/stickers/Cò Lõ/6.png",
      "/assets/images/stickers/Cò Lõ/7.png",
      "/assets/images/stickers/Cò Lõ/8.png",
      "/assets/images/stickers/Cò Lõ/9.png",
      "/assets/images/stickers/Cò Lõ/10.png",
      "/assets/images/stickers/Cò Lõ/11.png"
    ]
  },
  {
    name: "Mèo Méo",
    stickers: [
      "/assets/images/stickers/Mèo Méo/1.png",
      "/assets/images/stickers/Mèo Méo/2.png",
      "/assets/images/stickers/Mèo Méo/3.png",
      "/assets/images/stickers/Mèo Méo/4.png",
      "/assets/images/stickers/Mèo Méo/5.png",
      "/assets/images/stickers/Mèo Méo/6.png",
      "/assets/images/stickers/Mèo Méo/7.png",
      "/assets/images/stickers/Mèo Méo/8.png",
      "/assets/images/stickers/Mèo Méo/9.png",
      "/assets/images/stickers/Mèo Méo/10.png"
    ]
  },
  {
    name: "Quàng thượng on the mic",
    stickers: [
      "/assets/images/stickers/Quàng thượng on the mic/1.png",
      "/assets/images/stickers/Quàng thượng on the mic/2.png",
      "/assets/images/stickers/Quàng thượng on the mic/3.png",
      "/assets/images/stickers/Quàng thượng on the mic/4.png",
      "/assets/images/stickers/Quàng thượng on the mic/5.png",
      "/assets/images/stickers/Quàng thượng on the mic/6.png",
      "/assets/images/stickers/Quàng thượng on the mic/7.png",
      "/assets/images/stickers/Quàng thượng on the mic/8.png",
      "/assets/images/stickers/Quàng thượng on the mic/9.png",
      "/assets/images/stickers/Quàng thượng on the mic/10.png",
      "/assets/images/stickers/Quàng thượng on the mic/11.png",
      "/assets/images/stickers/Quàng thượng on the mic/12.png"
    ]
  }
];
